module.exports = __webpack_public_path__ + "static/img/financial-norms-ratios-logo.56ce13c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/financial-norms-ratios-logo.png
// module id = 6aan
// module chunks = 1